import { render, staticRenderFns } from "./my-task-title.vue?vue&type=template&id=4cc5f06b&"
import script from "./my-task-title.vue?vue&type=script&lang=ts&"
export * from "./my-task-title.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports